import React from 'react';

import Routes from 'config/routes';

import Step from 'components/stepper/Step';
import RecipesMenu from 'components/recipes/menu/RecipesMenu';

import ConfirmationDescription from './ConfirmationDescription';

const ConfirmationStep = ({
  recipe,
  pageTitle,
  goToPreviousStep,
  goToNextStep,
}) => {
  return (
    <Step
      key="confirmation"
      renderDescription={() => (
        <ConfirmationDescription></ConfirmationDescription>
      )}
      stepTitle={pageTitle}
      onBackButtonClick={goToPreviousStep}
      onNextButtonClick={goToNextStep}
      spacing={8}
      renderBody={() => {
        return (
          <RecipesMenu
            recipe={recipe}
            router={Routes.createRecipe}
          ></RecipesMenu>
        );
      }}
      nextStepLabel="CREATE RECIPE"
    ></Step>
  );
};

export default ConfirmationStep;
